<template>
  <form id="business-model-form" @submit.prevent>
    <!-- <div class="field">
      <label class="label">
        {{ getQuestionByTag('Q48').title }}
        <b-tooltip :label="getQuestionByTag('Q48').desc"
                   v-if="getQuestionByTag('Q48').desc !== ''"
                   type="is-light"

                   position="is-right" size="is-large" multilined>
          <div class="tooltip-icon">!</div>
        </b-tooltip>
      </label>
      <div class="sep-16"></div>
      <div class="control">
        <falcon-select :options="getQuestionByTag('Q48').answer_set" vrules="required" vtarget="input[type=hidden]"
                       label="title" v-model="formData['how_startup_make_money']" :multiple="true"></falcon-select>
      </div>
      <div class="help is-danger vrule" rule="required">
        This field is required.
      </div>
    </div> -->

    <radio-box :question="getQuestionByTag('Q48')"
               v-model="formData['Q48']"></radio-box>


    <radio-box :question="getQuestionByTag('Q49')"
               v-model="formData['Q49']"></radio-box>

    <radio-box :question="getQuestionByTag('Q50')"
               v-model="formData['Q50']"></radio-box>

    <radio-box :question="getQuestionByTag('Q51')"
               v-model="formData['Q51']"></radio-box>

    <radio-box :question="getQuestionByTag('Q52')"
               v-model="formData['Q52']"></radio-box>

    <radio-box :question="getQuestionByTag('Q53')"
               v-model="formData['Q53']"></radio-box>

    <radio-box :question="getQuestionByTag('Q54')"
               v-model="formData['Q54']"></radio-box>

    <radio-box :question="getQuestionByTag('Q55')"
               v-model="formData['Q55']"></radio-box>

    <radio-box :question="getQuestionByTag('Q56')"
               v-model="formData['Q56']"></radio-box>

    <radio-box :question="getQuestionByTag('Q57')"
               v-model="formData['Q57']"></radio-box>

    <radio-box :question="getQuestionByTag('Q58')"
               v-model="formData['Q58']"></radio-box>

    <radio-box :question="getQuestionByTag('Q59')"
               v-model="formData['Q59']"></radio-box>

  </form>
</template>

<script>
import {FormsMixin} from "@/modules/calculator/forms/FormsMixin";
import RadioBox from "@/modules/calculator/components/RadioBox";
import FalconSelect from "@/shared/forms/FalconSelect";
import FounderDetails from "@/modules/calculator/components/FounderDetails";
import {FormValidation} from "@/shared/directives/formValidation";
import {LookupsAPI} from "@/apis/LookupsAPI";

export default {
  name: "BusinessModelForm",
  mixins: [FormsMixin],
  components: {RadioBox, FalconSelect,},
  props: {
    questions: {
      type: Array,
      default: function () {
        return [];
      }
    },
    formData: Object
  },
  data() {
    return {
      answers: {},
      numberOfFounders: '',
      countries: [],
      foundersDetails: {},
      formValidation: null
    }
  },
  async mounted() {
    this.formValidation = new FormValidation('#business-model-form');
    this.countries = await LookupsAPI.getCountries();
  },
  methods: {
    getData() {
      let data = this.formatAnswers();
      // let how_startup_make_money = data['how_startup_make_money'].map((answer)=>{
      //   return {
      //       id: answer.id,
      //       tag: 'Q'+answer.question,
      //   }
      // })
      // data['answers'] = data['answers'].concat(how_startup_make_money);
      // delete data['how_startup_make_money'];
      return data;
    }
  }
}
</script>

<style scoped>

</style>
